var countdownClock = {
    init: function(el) {
        if ($(el).length > 0) {
            $(el).each(function() {
                var $this = $(this);
                var until = new Date($this.data('date'));
                var elements = $this.find('[data-countdown]');
                var element = null;
                if (elements.length) {
                    element = $(elements[0]);
                } else {
                    element = $('<span>');
                    element.attr({
                        'data-countdown': ''
                    });
                    element.appendTo($this);
                }
                $this.on('update.countdown', function(e) {
                    if (!e.elapsed) {
                        element.text(e.strftime('%Dd %Hh %Mm %Ss'));
                    }
                });

                $this.on('finish.countdown', function() {
                    $this.fadeOut();
                });

                $this.countdown(until);
            });
        }
    }
};
